const ShowComponent = ({ children, condition }) => {
  if (condition) {
    return children;
  } else return;
};

export default ShowComponent;
